import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { RdwCheckResult, RdwCheckRow } from '@fleet/shared';
import { api } from '../../lib/apiClient';
import { carKeys } from './fleet.api';

/** Run a bulk RDW check over every active car (on-demand, so a mutation). */
export function useRdwCheck() {
  return useMutation({
    mutationFn: () => api.get<{ result: RdwCheckResult }>('/rdw/check-all').then((r) => r.result),
  });
}

/** Apply the RDW values for the changed cars (APK date / catalogusprijs). */
export function useApplyRdwChanges() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (rows: RdwCheckRow[]) => {
      const changed = rows.filter((r) => r.status === 'gewijzigd' && r.changes.length > 0);
      for (const row of changed) {
        const patch = Object.fromEntries(row.changes.map((c) => [c.veld, c.rdw]));
        await api.patch(`/cars/${encodeURIComponent(row.kenteken)}`, patch);
      }
      return changed.length;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: carKeys.all });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
